import { cssVar, HeaderBar } from 'metrix-common3';

const AppBar = (props) => (
    <HeaderBar
        context={props.context}
        userName={props.context.session?.firstName}
        noOfElements={2}
        color={cssVar.colorPrimaryText}
        logoWidth='177'
        logoHeight='50'
        companyNameColor={cssVar.colorPrimaryText}
        userTypeColor='red'
        brandAvatarColor={cssVar.colorPrimary}
        {...props}
    />
);

export default AppBar;
